// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setFacilityList,
  setFloorList,
  setRoomList,
  setFacilityEditValue,
  setFloorEditValue,
  setRoomEditValue,
  resetFacilityManagement
} from 'src/store/modules/admin/facilityManagement'

const initialState = {
  facilityList: [],
  floorList: [],
  roomList: [],
  facilityEditValue: {},
  floorEditValue: {},
  roomEditValue: {}
}

export default handleActions(
  {
    [setFacilityList](state, { payload: facilityList }) {
      return {
        ...state,
        facilityList
      }
    },

    [setFloorList](state, { payload: floorList }) {
      return {
        ...state,
        floorList
      }
    },

    [setRoomList](state, { payload: roomList }) {
      return {
        ...state,
        roomList
      }
    },

    [setFacilityEditValue](state, { payload: facilityEditValue }) {
      return {
        ...state,
        facilityEditValue
      }
    },

    [setFloorEditValue](state, { payload: floorEditValue }) {
      return {
        ...state,
        floorEditValue
      }
    },

    [setRoomEditValue](state, { payload: roomEditValue }) {
      return {
        ...state,
        roomEditValue
      }
    },

    [resetFacilityManagement]() {
      return initialState
    }
  },
  initialState
)
